import classes from "./SectionTitle.module.scss";

const SectionTitle = props => {
  return (
  <h2 className={classes.Title + " " + props.customClass}>
    {props.text}
  </h2>
  )
}

export default SectionTitle;